/**
 * AI 대안을 지울 때 고를 수 있는 사유(선택) — 값 목록은 백엔드 `modules/experience/index.js` 의 `DROP_REASONS` 와 같아야 한다.
 * 어긋나면 고른 사유가 서버에서 조용히 「사유 없음」 으로 떨어진다. 표시는 `common:stn.dropReasons.<값>`.
 */
export const ALT_DROP_REASONS = ['wrongResult', 'noEffect', 'notApplicable', 'againstGuide', 'duplicate', 'other'];

/** 저장에 실을 모양 — { A2: 'noEffect' }. 사유를 고르지 않은 것은 싣지 않는다 */
export function dropReasonPayload(drops) {
  const out = {};
  for (const x of drops || []) if (x && x.id && ALT_DROP_REASONS.includes(x.reason)) out[x.id] = x.reason;
  return Object.keys(out).length ? out : undefined;
}
